import { render } from "./MessageBlock.vue?vue&type=template&id=7f97a654"
import script from "./MessageBlock.vue?vue&type=script&lang=js"
export * from "./MessageBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__